import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Posts from "../components/Posts/Posts";
import Sidebar from "../components/Sidebar/Sidebar";

export default function Home() {
  return (
    <>
      <Navbar />
      <section className="wrapper">
        <Sidebar />
        <Posts />
      </section>
    </>
  );
}
